module.exports = __webpack_public_path__ + "static/turntable-d336f4761371f376b1fe9e648d6501ec.jpg";